import React from "react";
import { User, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useProductInfo } from "../../hooks/useProductInfo";
import UserProfileIcon from "../../../../../shared/UserProfileIcon";
import BlockUserButton from "../../../../../shared/BlockUserButton/BlockUserButton";
import genericUtility from "../../../../../../services/utility/GenericUtility";
import "./styles/SellerCard.css";

const SellerCard: React.FC = () => {
  const { sellerName, sellerId, sellerVerified } = useProductInfo();
  const navigate = useNavigate();
  const currentUserId = genericUtility.getCookie("userId");

  if (!sellerName) return null;

  const handleViewProfile = () => {
    if (currentUserId && currentUserId === sellerId) {
      navigate("/my-listings");
    } else {
      navigate("/listings/" + sellerId);
    }
  };

  return (
    <div className="selv2 glass-card">
      <div className="selv2__header">
        <User size={18} strokeWidth={2.5} />
        <span className="selv2__label">Listed by</span>
      </div>
      <div className="selv2__content">
        <div className="selv2__profile-row">
          <UserProfileIcon
            userName={sellerName}
            userId={sellerId}
            isVerified={sellerVerified}
            darkBackground
            size="lg"
          />
        </div>
        <div className="selv2__actions-row">
          <button className="selv2__profile-btn" onClick={handleViewProfile}>
            View Profile
            <ChevronRight size={16} strokeWidth={2.5} />
          </button>
          <BlockUserButton
            userId={sellerId}
            userName={sellerName}
            currentUserId={currentUserId}
          />
        </div>
      </div>
    </div>
  );
};

export default SellerCard;
